import React, { PropTypes } from "react";
import styles from "components/documents/active-filters.scss";
import { ActiveFilterItem } from "components/documents/filters/active-filter-item";

export const CategoryRuleCellFormatter = ({ accountId, id, removeIncludeRule, value }) => {
  if ((value || []).length === 0) {
    return null;
  }
  return (
    <div className={ styles["active-filter-group"] }>
      { mapRenderItem(accountId, id, removeIncludeRule, value.includeVendors) }
    </div>
  );
};

CategoryRuleCellFormatter.defaultProps = {
  value: []
};

CategoryRuleCellFormatter.propTypes = {
  accountId: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  removeIncludeRule: PropTypes.func.isRequired,
  value: PropTypes.shape({ includeVendors: PropTypes.arrayOf(PropTypes.object) })
};

const mapRenderItem = (accountId, categoryId, removeIncludeRule, value) => (
  value.map(item => renderItem(accountId, categoryId, item.id, removeIncludeRule, item.vendorName))
);

const renderItem = (accountId, categoryId, ruleId, onRemoveItem, name) => (
  <span key={ `${name}-${ruleId}` } onClick={ (e) => e.stopPropagation() }>
    <ActiveFilterItem name={ name } onRemove={ () => onRemoveItem(accountId, categoryId, ruleId) } />
  </span>
);



// WEBPACK FOOTER //
// ./src/js/components/grid/cell-formatters/category-rule-cell-formatter.jsx